import is from '@sindresorhus/is';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Thread } from '../../data-contract/chat';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { chatKeys } from './query-keys';

export const useChatThread = (threadId: string | undefined): UseQueryResult<Thread, Error> => {
    const { fetchChatThread } = useApplicationFetchers();

    return useQuery({
        enabled: !is.undefined(threadId),
        queryFn: async () => {
            if (is.undefined(threadId)) {
                throw new Error('threadId required');
            }

            const result = await fetchChatThread(threadId);

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: chatKeys.thread(threadId ?? ''),
    });
};
